import React from 'react'
import styled from 'styled-components'
import { ErrorMessage } from 'formik'
import FormErrorMessage from 'components/form-components/FormErrorMessage'
import FormCheckbox from './FormCheckbox'

const InputBlock = styled.div`
  margin-bottom: 10px;
`

const InputWrap = styled.div`
  position: relative;
  z-index: 0;
`

const FormCheckboxes = ({ name, options, fullWidth }) => (
  <InputBlock>
    <InputWrap>
      {options.map(({ label, value }, key) => (
        <FormCheckbox
          key={key}
          name={name}
          fullWidth={fullWidth}
          label={label}
          value={value}
        />
      ))}
    </InputWrap>
    <ErrorMessage component={FormErrorMessage} name={name} />
  </InputBlock>
)

export default FormCheckboxes
